"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLAYLIST_IMAGES = void 0;
const playlists__360__1__jpg_1 = __importDefault(require("../../resources/img/playlists__360 (1).jpg"));
const playlists__360__2__jpg_1 = __importDefault(require("../../resources/img/playlists__360 (2).jpg"));
const playlists__360__3__jpg_1 = __importDefault(require("../../resources/img/playlists__360 (3).jpg"));
const playlists__360__4__jpg_1 = __importDefault(require("../../resources/img/playlists__360 (4).jpg"));
const playlists__360__5__jpg_1 = __importDefault(require("../../resources/img/playlists__360 (5).jpg"));
const playlists__360__6__jpg_1 = __importDefault(require("../../resources/img/playlists__360 (6).jpg"));
const playlists__360__7__jpg_1 = __importDefault(require("../../resources/img/playlists__360 (7).jpg"));
const playlists__360__8__jpg_1 = __importDefault(require("../../resources/img/playlists__360 (8).jpg"));
const playlists__1__jpg_1 = __importDefault(require("../../resources/img/playlists (1).jpg"));
const playlists__2__jpg_1 = __importDefault(require("../../resources/img/playlists (2).jpg"));
const playlists__3__jpg_1 = __importDefault(require("../../resources/img/playlists (3).jpg"));
const playlists__4__jpg_1 = __importDefault(require("../../resources/img/playlists (4).jpg"));
const playlists__5__jpg_1 = __importDefault(require("../../resources/img/playlists (5).jpg"));
const playlists__6__jpg_1 = __importDefault(require("../../resources/img/playlists (6).jpg"));
const playlists__7__jpg_1 = __importDefault(require("../../resources/img/playlists (7).jpg"));
const playlists__8__jpg_1 = __importDefault(require("../../resources/img/playlists (8).jpg"));
const playlists__1440__1__jpg_1 = __importDefault(require("../../resources/img/playlists__1440 (1).jpg"));
const playlists__1440__2__jpg_1 = __importDefault(require("../../resources/img/playlists__1440 (2).jpg"));
const playlists__1440__3__jpg_1 = __importDefault(require("../../resources/img/playlists__1440 (3).jpg"));
const playlists__1440__4__jpg_1 = __importDefault(require("../../resources/img/playlists__1440 (4).jpg"));
const playlists__1440__5__jpg_1 = __importDefault(require("../../resources/img/playlists__1440 (5).jpg"));
const playlists__1440__6__jpg_1 = __importDefault(require("../../resources/img/playlists__1440 (6).jpg"));
const playlists__1440__7__jpg_1 = __importDefault(require("../../resources/img/playlists__1440 (7).jpg"));
const playlists__1440__8__jpg_1 = __importDefault(require("../../resources/img/playlists__1440 (8).jpg"));
const SMALL_IMAGES = [
    playlists__360__1__jpg_1.default,
    playlists__360__2__jpg_1.default,
    playlists__360__3__jpg_1.default,
    playlists__360__4__jpg_1.default,
    playlists__360__5__jpg_1.default,
    playlists__360__6__jpg_1.default,
    playlists__360__7__jpg_1.default,
    playlists__360__8__jpg_1.default,
];
const NORMAL_IMAGES = [
    playlists__1__jpg_1.default,
    playlists__2__jpg_1.default,
    playlists__3__jpg_1.default,
    playlists__4__jpg_1.default,
    playlists__5__jpg_1.default,
    playlists__6__jpg_1.default,
    playlists__7__jpg_1.default,
    playlists__8__jpg_1.default,
];
const BIG_IMAGES = [
    playlists__1440__1__jpg_1.default,
    playlists__1440__2__jpg_1.default,
    playlists__1440__3__jpg_1.default,
    playlists__1440__4__jpg_1.default,
    playlists__1440__5__jpg_1.default,
    playlists__1440__6__jpg_1.default,
    playlists__1440__7__jpg_1.default,
    playlists__1440__8__jpg_1.default,
];
exports.PLAYLIST_IMAGES = {
    small: SMALL_IMAGES,
    normal: NORMAL_IMAGES,
    big: BIG_IMAGES,
};
